import React from "react";
import { MailIcon } from "@heroicons/react/solid";

const Contact = () => {
  const email = "manan.sharma.dev@gmail.com";
  const subject = "Portfolio Inquiry";

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  };

  return (
    <div id="Contact" className="pb-72 mt-36">
      <div className="table mx-12 lg:mx-60">
        <MailIcon className="h-5 w-5 mr-4 text-yellow_vs" />
        <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
          Get In Touch
        </code>
        <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
      </div>
      <div className="text-[#a2aabc] text-lg mt-5 mx-12 lg:mx-60 flex flex-col items-center text-justify">
        <code>
          Feel free to reach out to me for any inquiries or opportunities!
        </code>
        <button
          onClick={handleEmailClick}
          className="border border-lightblue_vs text-lightblue_vs mt-10 px-6 py-3 rounded hover:bg-opacity-10 hover:bg-lightblue_vs transition-colors text-center"
        >
          <code className="text-sm sm:text-base break-all">{email}</code>
        </button>
        <div className="mt-6 text-sm text-[#858585]">
          <code>Click the button above to send me an email</code>
        </div>
      </div>
    </div>
  );
};

export default Contact;
